import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";

//Context
import { useAuth } from "../../contexts/AuthContext";

/**
 * Logouts the user
 * @param {*} props
 */
const Logout = () => {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const [isLoggedOut, setIsLoggedOut] = React.useState(false);

    useEffect(() => {
        const handleLogout = async () => {
            await logout();
            setIsLoggedOut(true);
        };
        handleLogout();
    }, [logout]);

    if (isLoggedOut) {
        return <Navigate to="/login" />;
    }

    document.title = "Logout | Chatvia React - Responsive Bootstrap 5 Chat App";

    return <React.Fragment></React.Fragment>;
};

export default Logout;
